import React from 'react'
import type { DataToolProps } from './Context'
import { Provider } from './Context'
import { Layout } from './Layout'

export const DataTool = (props: DataToolProps) => {
  return (
    <Provider {...props}>
      <Layout />
    </Provider>
  )
}
